module.exports = __webpack_public_path__ + "img/extended.c211347f.png";